import { render, staticRenderFns } from "./zuoxitongji.vue?vue&type=template&id=01da3983&scoped=true&"
import script from "./zuoxitongji.vue?vue&type=script&lang=js&"
export * from "./zuoxitongji.vue?vue&type=script&lang=js&"
import style0 from "./zuoxitongji.vue?vue&type=style&index=0&id=01da3983&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da3983",
  null
  
)

export default component.exports